module.exports = __webpack_public_path__ + "static/media/image (12).b0e3cfc7.jpg";